import {AfterViewInit, Component, OnInit} from "@angular/core";
import {ElementService} from "../services/element.service";
import {StepService} from "../services/step.service";
import {Router} from "@angular/router";
import {PortalService} from "../services/portal.service";

/**
 * Special component for the step energy-map-donated if a Berlin ZIP code was entered at the beginning of the advisor.
 */
@Component({
  selector: 'app-energy-donated-map',
  templateUrl: './energy.map.donated.component.html'
})
export class EnergyMapDonatedComponent implements OnInit, AfterViewInit {
  /**
   * Advisor name
   */
  advisorName: string = '';

  /**
   * Unique hash code
   */
  hashCode: string = '';

  /**
   * prefix for some text keys. Can be used to indicate the advisors or others.
   */
  textkeyPrefix: string = '';

  /**
   * The last step were we should navigate with the back button to.
   */
  lastStep: string = null;

  /**
   * The next step were we should navigate with the next button to.
   */
  nextStep: string = null;

  /**
   * Requestservice to talk with the backend
   * @protected
   */
  protected requestService: any;

  /**
   * the anfrage object with the input of the user
   */
  anfrage: any;

  /**
   * @param elementService
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService,
              protected portalService: PortalService) {
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {}

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    // scroll to the top
    const element = document.querySelector('body');
    this.elementService.scrollToElement(element);
  }

}
